import { getTimeDefinitionService } from '../../../core/services/TimeDefinitionService.js';

const VALID_TIME_OF_DAY = ['day', 'sunset', 'night'];

const hourToBackdropSlot = (hour) => {
    if (hour >= 5 && hour < 17) return 'day';
    if (hour >= 17 && hour < 20) return 'sunset';
    return 'night';
};

export const parseClockHour = (value) => {
    if (value == null || value === '') return null;

    let hour;
    if (typeof value === 'string' && value.includes(':')) {
        hour = parseInt(value.split(':')[0], 10);
    } else {
        hour = typeof value === 'number' ? value : parseInt(value, 10);
    }

    if (!Number.isInteger(hour) || hour < 0 || hour >= 24) return null;
    return hour;
};

export const shouldPreserveLocalBackdrop = (config) => config?.preserveLocalBackdrop === true;

export const shouldSeedScenarioBackdrop = (config) =>
    config?.isNewConversation === true && !shouldPreserveLocalBackdrop(config);

export const resolveScenarioBackdrop = (scenario) => {
    if (!scenario || typeof scenario !== 'object') return null;

    const rawLoc = scenario.loc_id ?? scenario.loc;
    const locText = rawLoc == null ? '' : String(rawLoc).trim();
    const locId = locText && locText !== '0' && !locText.startsWith('ERROR') ? locText : null;

    const startHour = parseClockHour(scenario.startTime);
    let timeHour = startHour;
    let timeOfDay = null;

    if (timeHour == null && scenario.time != null && scenario.time !== '') {
        const slot = getTimeDefinitionService().getTimeOfDayFromNumericSlot(scenario.time);
        if (VALID_TIME_OF_DAY.includes(slot)) {
            timeOfDay = slot;
            timeHour = getTimeDefinitionService().getDefaultHour(slot);
        }
    } else if (timeHour != null) {
        timeOfDay = hourToBackdropSlot(timeHour);
    }

    if (!locId && timeHour == null) return null;

    return { locId, timeOfDay, timeHour };
};

export const resolvePreservedClockHour = (config, manualHour = null) => {
    const storedHour = parseClockHour(config?.timeHour);
    if (storedHour != null) return storedHour;

    const overrideHour = parseClockHour(manualHour);
    if (overrideHour != null) return overrideHour;

    if (VALID_TIME_OF_DAY.includes(config?.timeOfDay)) {
        return getTimeDefinitionService().getDefaultHour(config.timeOfDay);
    }

    return null;
};

export const applyScenarioBackdropToConfig = (config, scenario) => {
    const resolved = resolveScenarioBackdrop(scenario);
    const next = { ...(config || {}), preserveLocalBackdrop: false };
    delete next.backgroundUrl;

    next.loc_id = resolved?.locId ?? null;
    next.timeOfDay = resolved?.timeOfDay ?? null;
    next.timeHour = resolved?.timeHour ?? null;
    return next;
};
